/**
* Department Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Department Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import lottie from 'lottie-web';
( function( app ) {
  const COMPONENT = {

    className: 'department-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.department-banner' ).each( function( key, val ) {
        if ( $( this ).find( '.animation-wrapper' ).length ) {
          const animation = lottie.loadAnimation( {
            container: $( this ).find( '.animation-wrapper' )[0],
            renderer: 'svg',
            name: 'department-banner-animation',
            loop: true,
            autoplay: false,
            path: $( this ).find( '.animation-wrapper' ).attr( 'data-url' ),
          } );

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 75%',
              end: 'bottom top',
              scrub: 0,
              onEnter: ( {progress, direction, isActive} ) => {
                lottie.play( 'department-banner-animation' );
              },
            },
          } );
        }

        const bgImage = $( this ).find( '.background-image' )[0];
        const height = $( this ).outerHeight();

        const imagePopper = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0,
            onEnter: ( {progress, direction, isActive} ) => {
              $( bgImage ).addClass( 'is-loaded' );
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'department-banner', COMPONENT );
} )( app );
